export default __webpack_public_path__ + "static/media/i_groupsale_medium_grey.a365e33f.png";